import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { trackLink } from '../lib/analytics-helper';
//import i18n from '../lib/reacti18n';
import getContent from 'pp-react-l10n';

class Topicscontainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const getTopicsHeading = getContent('staticContent');
    const topicsInfo = this.props.topicsInfo.filter(
      (section) => section.ref_key.toLowerCase() !== 'thank-you'
    );
    const country = (this.props.country).toLowerCase();
    const fontChange = country === 'vn' && this.props.locale === 'vi_VN' ? 'vnFont' : country === 'jp' && this.props.locale === 'ja_JP'? 'jpFont': '';
    return (
      <div id="topics-container" className="topicsContainer">
        <div className="topicsSection vx_text-2">
            <div className="topicsHeading">
                <h2 className={`vx_text-4 header_style ${fontChange}`}>{getTopicsHeading('brc.topicsHeader')}</h2>
            </div>
        <div className="topic_list">
            <ul className="inlineList">
            {topicsInfo.map((topic, index) => {
              return(
                    <li key = {index} className="panel panel1 vx_text-body">
                      <div key = {index} className = "wrap">
                        <a
                          data-pa-click={JSON.stringify({
                            link: `Topicscontainer-link-${topic.ref_key}`,
                            event_name: "brc_topic_clicked"
                          })}
                          className="vx_text-body li_style"
                          href={this.props.attachUrl.length>0 ? `/${country}/brc/topics/${topic.ref_key}?${this.props.attachUrl}` : `/${country}/brc/topics/${topic.ref_key}`}>{topic.title}
                          <div key = {index} className = "rightArrow"  /></a>
                      </div>
                    </li>
              );
            })
            }
            </ul>
        </div>
        </div>
      </div>
    );
  }
    }

Topicscontainer.propTypes = {
  topicsInfo: PropTypes.array,
  country: PropTypes.string

};

export default Topicscontainer;
